<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" *ngIf="items.length > 0" [config]="slickConfig">
  <ng-container *ngFor="let item of items">
    <div ngxSlickItem *ngIf="item | async as data" class="slide">
      <div class="item">
        <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: data } | cxUrl">
          <span class="prod-image">
            <cx-media
              [container]="getImageRendition(data?.images?.PRIMARY)"
              format="product"
              [class.is-missing-fish]="businessType === 'fish'"
            ></cx-media>
          </span>
          <span class="prod-sku">
            {{ data.code }}
          </span>
          <span class="prod-name" [innerHTML]="data.name"></span>
          <span class="prod-price">
            <ng-template [ngIf]="!showSrp">
              <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
              <span class="p-price">
                <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(data.code); else dealerPriceReady">
                  <div class="spinner-shimano" *ngIf="this.hasDealerPrice">
                    <div></div>
                  </div>
                  <div class="no-dealer-price no-dealer-price-pcn" *ngIf="!this.hasDealerPrice"></div>
                </div>
                <ng-template #dealerPriceReady>
                  {{ dealerPrice(data.code) }}
                </ng-template>
              </span>
            </ng-template>
            <ng-template [ngIf]="showSrp">
              <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
              <span class="p-price">{{ data.srpPrice?.formattedValue }}</span>
            </ng-template>
          </span>
        </a>
      </div>
    </div>
  </ng-container>
</ngx-slick-carousel>
